module.exports = __webpack_public_path__ + "img/leeb-balkone-transporter.9f8caf8c.jpeg";